// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"25":"ui/main/css/main","362":"ui/main/css/joy_product_page","582":"ui/main/css/custom_search","711":"ui/main/css/joy_blog"}[chunkId] + ".css";
};